module.exports = __webpack_public_path__ + "img/calendar-12_fill.876d8230.svg";